import { Component, OnInit } from '@angular/core';
import { interval, pipe, startWith, Subject, switchMap, takeUntil } from 'rxjs';
import { GlobalService } from 'src/app/services/global.service';
import { SysLogService } from 'src/app/services/sys-log.service';
import { TramDoService } from 'src/app/thmp-monitoring/services/tram-do.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  dataSource: any[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private _tramDoService: TramDoService,
    private _globalService: GlobalService
  ) {
  }

  ngOnInit() {
    //this.getData();

    this.getData();

    interval(120000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getData();
        console.log('dashboard interval running');
      });

    // const posts$ = interval(120000)
    //   .pipe(this.myCustomOperator())
    //   .subscribe((val) => {
    //     console.log(val);
    //   });

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  getData() {
    this._tramDoService.getsAllByUser().then((res) => {
      if (res.success) {
        this.dataSource = res.data;
      }
    });
  }

  getCapGio(dmYeuToDoDtos: any[]) {
    let yeuTodoGio = dmYeuToDoDtos.filter(x => x.code == 'AI03')[0];
    if (yeuTodoGio) {
      return this._globalService.getCapGio(yeuTodoGio.giaTri);
    }
    return '-';
  }

  getBackgroudImageTrangThaiHoatDong(tramDoInfo: { trangThaiHoatDong: number, trangThaiHoatDongData: number }) {
    switch (tramDoInfo.trangThaiHoatDong) {
      case 1:
        switch (tramDoInfo.trangThaiHoatDongData) {
          case 2:
            return 'background-image: url("assets/images/bg2.jpg")';
          case 3:
            return 'background-image: url("assets/images/bg3.jpg")';
          case 4:
            return 'background-image: url("assets/images/bg4.jpg")';
          default:
            return '';
        }
      case 2:
        return 'background-image: url("assets/images/bg2.jpg")';
      case 3:
        return 'background-image: url("assets/images/bg3.jpg")';
      case 4:
        return 'background-image: url("assets/images/bg4.jpg")';
      default:
        return '';
    }
  }

  getTrangThaiHoatDong(tramDoInfo: { trangThaiHoatDong: number, trangThaiHoatDongData: number }) {
    switch (tramDoInfo.trangThaiHoatDong) {
      case 1:
        switch (tramDoInfo.trangThaiHoatDongData) {
          case 2:
            return 'Đang đo';
          case 3:
            return 'Hiệu chuẩn';
          case 4:
            return 'Lỗi thiết bị';
          default:
            return '';
        }
      case 2:
        return 'Đang đo';
      case 3:
        return 'Hiệu chuẩn';
      case 4:
        return 'Lỗi thiết bị';
      default:
        return '';
    }
  }

  getTrangThaiHoatDongStyle(tramDoInfo: { trangThaiHoatDong: number, trangThaiHoatDongData: number }) {
    switch (tramDoInfo.trangThaiHoatDong) {
      case 1:
        switch (tramDoInfo.trangThaiHoatDongData) {
          case 2:
            return 'text-success';
          case 3:
            return 'text-warning';
          case 4:
            return 'Lỗi thiết bị';
          default:
            return 'Hiệu chuẩn';
        }
      case 2:
        return 'text-success';
      case 3:
        return 'text-warning';
      case 4:
        return 'Lỗi thiết bị';
      default:
        return 'Hiệu chuẩn';
    }
  }

  getNumSequence(data: any): Array<number> {
    var n = data.maxCountDmYeuToDo - data.dmYeuToDoDtos.length;
    return Array(n);
  }

  myCustomOperator() {
    return pipe(
      startWith(""),
      switchMap(async () => this.getData())
    );
  }

}
